module.exports = __webpack_public_path__ + "static/img/courseIcon.d79a01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/courseIcon.png
// module id = 3Ky6
// module chunks = 1